import { NgModule } from '@angular/core';
import { CustomHeaderComponent } from './custom-header.component';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../material/material.module';
import { GenericFormBtnModule } from '../generic-btn/generic-btn.module';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        GenericFormBtnModule,
    ],
    declarations: [
        CustomHeaderComponent,
    ],
    exports: [
        CustomHeaderComponent,
    ]
})
export class CustomHeaderModule { }
